export function Logo({ className = "", showText = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="relative h-7 w-7 rounded-md bg-amber-500 flex items-center justify-center shrink-0">
        <div className="h-3 w-3 rounded-sm bg-background rotate-45" />
        <div className="absolute h-1.5 w-1.5 rounded-full bg-amber-500" />
      </div>
      {showText && <span className="font-display text-lg font-bold tracking-tight text-foreground">DealsOps</span>}
    </div>
  );
}
